import { defineAsyncComponent } from '../../lib/utils/vue3compat/vue.js?vue3';
import { GlButton, GlAlert, GlLink, GlLoadingIcon, GlFormCheckbox, GlFormGroup, GlFormSelect, GlSprintf, GlIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { clearDraft } from '~/lib/utils/autosave';
import { isMetaEnterKeyPair } from '~/lib/utils/common_utils';
import { getParameterByName } from '~/lib/utils/url_utility';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { s__, sprintf, __ } from '~/locale';
import { fetchPolicies } from '../../lib/graphql.js?vue3';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { addHierarchyChild, setNewWorkItemCache } from '../graphql/cache_utils.js?vue3';
import { findWidget } from '../list/utils.js?vue3';
import { addShortcutsExtension } from '../../behaviors/shortcuts/index.js?vue3';
import ZenMode from '~/zen_mode';
import ShortcutsWorkItems from '../../behaviors/shortcuts/shortcuts_work_items.js?vue3';
import WorkItemDates from '../../../../../ee/app/assets/javascripts/work_items/components/work_item_dates.vue?vue3';
import WorkItemMetadataProvider from './work_item_metadata_provider.vue?vue3';
import DetailLayout from '../../vue_shared/components/detail_layout.vue?vue3';
import { findAssigneesWidget, findColorWidget, findCrmContactsWidget, findCustomFieldsWidget, findHealthStatusWidget, findHierarchyWidget, findParticipantsWidget, findIterationWidget, findLabelsWidget, findMilestoneWidget, findStatusWidget, findWeightWidget, getDisplayReference, getNewWorkItemAutoSaveKey, getNewWorkItemWidgetsAutoSaveKey, lowercaseWorkItemType, updateDraftWorkItemType, newWorkItemFullPath, getLastUsedWorkItemTypeIdForNamespace, setLastUsedWorkItemTypeIdForNamespace } from '../utils.js?vue3';
import { TYPENAME_MERGE_REQUEST, TYPENAME_VULNERABILITY, TYPENAME_WORK_ITEMS_TYPE } from '~/graphql_shared/constants';
import { I18N_WORK_ITEM_ERROR_CREATING, i18n, WIDGET_TYPE_ASSIGNEES, WIDGET_TYPE_COLOR, NEW_WORK_ITEM_IID, WIDGET_TYPE_HEALTH_STATUS, WIDGET_TYPE_DESCRIPTION, NEW_WORK_ITEM_GID, WIDGET_TYPE_LABELS, WIDGET_TYPE_WEIGHT, WIDGET_TYPE_START_AND_DUE_DATE, WIDGET_TYPE_CRM_CONTACTS, WIDGET_TYPE_LINKED_ITEMS, WIDGET_TYPE_DEVELOPMENT, WIDGET_TYPE_ITERATION, WIDGET_TYPE_MILESTONE, DEFAULT_EPIC_COLORS, WIDGET_TYPE_HIERARCHY, WIDGET_TYPE_CUSTOM_FIELDS, CUSTOM_FIELDS_TYPE_NUMBER, CUSTOM_FIELDS_TYPE_TEXT, WORK_ITEM_TYPE_NAME_ISSUE, WIDGET_TYPE_STATUS, WORK_ITEM_CREATE_SOURCES, WORK_ITEM_TYPE_NAME_TICKET, CREATION_CONTEXT_NEW_ROUTE } from '../constants';
import { TITLE_LENGTH_MAX } from '../../issues/constants';
import createWorkItemFeatures from '../graphql/create_work_item_features.query.graphql';
import createWorkItemMutation from '../graphql/create_work_item.mutation.graphql';
import namespaceWorkItemTypesQuery from '../graphql/namespace_work_item_types.query.graphql';
import workItemTypesConfigurationQuery from '../graphql/work_item_types_configuration.query.graphql';
import workItemByIidQuery from '../graphql/work_item_by_iid.query.graphql';
import workItemCrmContactsQuery from '../graphql/work_item_crm_contacts.query.graphql';
import updateNewWorkItemMutation from '../graphql/update_new_work_item.mutation.graphql';
import TitleSuggestions from './title_suggestions.vue?vue3';
import WorkItemNamespaceListbox from './shared/work_item_namespace_listbox.vue?vue3';
import WorkItemTitle from './work_item_title.vue?vue3';
import WorkItemDescription from './work_item_description.vue?vue3';
import WorkItemAssignees from './work_item_assignees.vue?vue3';
import WorkItemLabels from './work_item_labels.vue?vue3';
import WorkItemMilestone from './work_item_milestone.vue?vue3';
import WorkItemParent from './work_item_parent.vue?vue3';
import WorkItemLoading from './work_item_loading.vue';
import WorkItemCrmContacts from './work_item_crm_contacts.vue?vue3';
export default {
    name: 'CreateWorkItem',
    components: {
        GlButton,
        GlAlert,
        GlLink,
        GlLoadingIcon,
        GlFormGroup,
        GlFormCheckbox,
        GlFormSelect,
        GlSprintf,
        GlIcon,
        WorkItemDescription,
        WorkItemTitle,
        WorkItemAssignees,
        WorkItemLabels,
        WorkItemMilestone,
        WorkItemLoading,
        WorkItemCrmContacts,
        WorkItemNamespaceListbox,
        TitleSuggestions,
        WorkItemParent,
        WorkItemDates,
        WorkItemWeight: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/work_items/components/work_item_weight.vue?vue3')),
        WorkItemHealthStatus: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/work_items/components/work_item_health_status.vue?vue3')),
        WorkItemColor: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/work_items/components/work_item_color.vue?vue3')),
        WorkItemIteration: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/work_items/components/work_item_iteration.vue?vue3')),
        WorkItemCustomFields: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/work_items/components/work_item_custom_fields.vue?vue3')),
        WorkItemStatus: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/work_items/components/work_item_status.vue?vue3')),
        DetailLayout,
        WorkItemMetadataProvider
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    inject: {
        contributionGuidePath: {
            default: ''
        },
        groupPath: {
            default: ''
        },
        getWorkItemTypeConfiguration: {
            default: ()=>{}
        }
    },
    i18n: {
        contributionGuidelinesText: s__('WorkItem|Please review the %{linkStart}contribution guidelines%{linkEnd} for this project.'),
        suggestionTitle: s__('WorkItem|Similar items'),
        similarWorkItemHelpText: s__('WorkItem|These existing items have a similar title and may represent potential duplicates.'),
        resolveOneThreadText: s__('WorkItem|Creating this %{workItemType} will resolve the thread in'),
        resolveAllThreadsText: s__('WorkItem|Creating this %{workItemType} will resolve all threads in')
    },
    props: {
        confidential: {
            type: Boolean,
            required: false,
            default: false
        },
        creationContext: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        fullPath: {
            type: String,
            required: true
        },
        hideFormTitle: {
            type: Boolean,
            required: false,
            default: false
        },
        hideNamespaceSelector: {
            type: Boolean,
            required: false,
            default: false
        },
        hideTypeSelector: {
            type: Boolean,
            required: false,
            default: false
        },
        isGroup: {
            type: Boolean,
            required: false,
            default: false
        },
        parentId: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        preselectedWorkItemType: {
            type: String,
            required: false,
            default: null
        },
        relatedItem: {
            type: Object,
            required: false,
            validator: (i)=>i.id && i.type && i.reference && i.webUrl,
            default: null
        },
        mergeRequestId: {
            type: String,
            required: false,
            default: null
        },
        mergeRequestLinkType: {
            type: String,
            required: false,
            default: null
        },
        shouldDiscardDraft: {
            type: Boolean,
            required: false,
            default: false
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
     * Restricts the namespace selector to projects. Use for callers that can
     * only create work item types which do not exist at the group level.
     */ allowProjectsOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        createSource: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'change-type',
        'confirm-cancel',
        'discard-draft',
        'error',
        'update-type',
        'work-item-created'
    ],
    data () {
        return {
            availableFeatures: {},
            isTitleValid: true,
            isConfidential: this.confidential || Boolean(getParameterByName('vulnerability_id')) || parseBoolean(getParameterByName('issue[confidential]')),
            isRelatedToItem: true,
            localTitle: this.title || '',
            localDescription: this.description || '',
            error: null,
            workItem: {},
            crmContactsWorkItem: {},
            namespace: null,
            workItemTypesConfiguration: {},
            selectedWorkItemTypeId: null,
            loading: false,
            initialLoadingWorkItem: true,
            initialLoadingWorkItemTypes: true,
            initialLoadingWorkItemTypesConfiguration: true,
            selectedNamespacePath: this.initialSelectedProject(),
            selectedNamespaceObject: null,
            discussionToResolve: getParameterByName('discussion_to_resolve'),
            mergeRequestToResolveDiscussionsOf: getParameterByName('merge_request_id'),
            vulnerabilityId: getParameterByName('vulnerability_id'),
            numberOfDiscussionsResolved: '',
            selectedParentMilestone: null
        };
    },
    apollo: {
        workItem: {
            query: workItemByIidQuery,
            variables () {
                return {
                    fullPath: this.newWorkItemPath,
                    iid: NEW_WORK_ITEM_IID,
                    useWorkItemFeatures: this.useWorkItemFeatures
                };
            },
            skip () {
                return this.skipWorkItemQuery;
            },
            update (data) {
                return data?.namespace?.workItem ?? {};
            },
            result () {
                this.initialLoadingWorkItem = false;
            },
            error () {
                this.error = i18n.fetchError;
            }
        },
        namespace: {
            query () {
                return namespaceWorkItemTypesQuery;
            },
            variables () {
                return {
                    fullPath: this.selectedNamespacePath
                };
            },
            update (data) {
                return data.namespace;
            },
            skip () {
                return this.initialLoadingWorkItemTypesConfiguration;
            },
            result () {
                this.initialLoadingWorkItemTypes = false;
                this.processWorkItemTypes();
            },
            error () {
                this.error = s__('WorkItem|Something went wrong when fetching work item types. Please try again');
            }
        },
        workItemTypesConfiguration: {
            query: workItemTypesConfigurationQuery,
            fetchPolicy: fetchPolicies.NETWORK_ONLY,
            variables () {
                return {
                    fullPath: this.selectedNamespacePath,
                    // Scoped to the selected namespace, not the page's, so it must not overwrite the
                    // page namespace's filterable flags.
                    // See issue https://gitlab.com/gitlab-org/gitlab/-/work_items/606810
                    includeFilterableFlags: false
                };
            },
            update (data) {
                const nodes = data?.namespace?.workItemTypes?.nodes || [];
                // Transform array to hash keyed by type id
                return nodes.reduce((acc, type)=>{
                    return {
                        ...acc,
                        [type.id]: type
                    };
                }, {});
            },
            result () {
                this.initialLoadingWorkItemTypesConfiguration = false;
            },
            error () {
                this.error = s__('WorkItem|Something went wrong when fetching work item types configuration. Please try again');
            }
        },
        crmContactsWorkItem: {
            query: workItemCrmContactsQuery,
            fetchPolicy: fetchPolicies.CACHE_ONLY,
            variables () {
                return {
                    fullPath: this.newWorkItemPath,
                    iid: NEW_WORK_ITEM_IID,
                    useWorkItemFeatures: this.useWorkItemFeatures
                };
            },
            skip () {
                return this.skipWorkItemQuery;
            },
            update (data) {
                return data?.namespace?.workItem ?? {};
            }
        },
        availableFeatures: {
            query: createWorkItemFeatures,
            variables () {
                return {
                    fullPath: this.fullPath
                };
            },
            update (data) {
                return data?.namespace?.availableFeatures ?? {};
            }
        }
    },
    computed: {
        isNamespaceTypeGroup () {
            // When user selects a namespace from the Namespace selector dropdown,
            // selectedNamespaceObject is set to the full namespace object within
            // handleNamespaceSelect called via the dropdown's `select-namespace`
            // event.
            // We check __typename === 'Group' to reliably identify groups
            // as there's no other field that can represent a group correctly.
            return this.selectedNamespaceObject ? this.selectedNamespaceObject.__typename === 'Group' : this.isGroup;
        },
        useWorkItemFeatures () {
            return Boolean(this.glFeatures.workItemFeaturesField);
        },
        workItemTypeConfiguration () {
            return this.getWorkItemTypeConfiguration?.(this.selectedWorkItemTypeName);
        },
        workItemTypes () {
            return this.namespace?.workItemTypes?.nodes ?? [];
        },
        creatableWorkItemTypes () {
            return this.workItemTypes.filter((type)=>{
                const config = this.workItemTypesConfiguration[type.id];
                return config?.canUserCreateItems ?? false;
            });
        },
        newWorkItemPath () {
            return newWorkItemFullPath(this.selectedNamespacePath, this.selectedWorkItemTypeName);
        },
        canSetNewWorkItemMetadata () {
            return this.namespace?.userPermissions.setNewWorkItemMetadata;
        },
        noMetadataSetPermissionMessage () {
            return sprintf(s__('WorkItem|Only %{namespaceType} members can add metadata.'), {
                namespaceType: this.isGroup ? __('group') : __('project')
            });
        },
        isLoading () {
            return this.initialLoadingWorkItemTypes || this.initialLoadingWorkItem && !this.skipWorkItemQuery || this.$apollo.queries.availableFeatures.loading;
        },
        isWorkItemTypesLoading () {
            return this.$apollo.queries.namespace.loading || this.$apollo.queries.workItemTypesConfiguration.loading;
        },
        skipWorkItemQuery () {
            return !this.selectedNamespacePath || !this.selectedWorkItemTypeName;
        },
        hasWidgets () {
            return this.workItem?.widgets?.length > 0 || this.useWorkItemFeatures && Object.keys(this.workItem?.features || {}).length > 0;
        },
        relatedItemId () {
            return this.relatedItem?.id;
        },
        relatedItemReference () {
            return getDisplayReference(this.selectedNamespacePath, this.relatedItem.reference);
        },
        relatedItemType () {
            return lowercaseWorkItemType(this.relatedItem?.type);
        },
        workItemAssignees () {
            return findAssigneesWidget(this.workItem);
        },
        workItemMilestone () {
            return findMilestoneWidget(this.workItem);
        },
        workItemLabels () {
            return findLabelsWidget(this.workItem);
        },
        workItemIteration () {
            return findIterationWidget(this.workItem);
        },
        workItemWeight () {
            return findWeightWidget(this.workItem);
        },
        workItemHealthStatus () {
            return findHealthStatusWidget(this.workItem);
        },
        workItemColor () {
            return findColorWidget(this.workItem);
        },
        workItemHierarchy () {
            return findHierarchyWidget(this.workItem);
        },
        showParentAttribute () {
            // We use the work item create work flow for incidents although
            // incidents haven't been migrated to work items and use the legacy
            // detail view instead. Since the legacy view doesn't support setting a parent
            // we need to hide this attribute here until the migration has been finished.
            // https://gitlab.com/gitlab-org/gitlab/-/issues/502823
            if (this.workItemTypeConfiguration?.isIncidentManagement) {
                return false;
            }
            // Hide Parent widget on work item creation according to license permissions
            if (!this.validateAllowedParentTypes(this.selectedWorkItemTypeName).length) return false;
            return Boolean(this.workItemHierarchy);
        },
        workItemCrmContacts () {
            return findCrmContactsWidget(this.workItem);
        },
        workItemTypesForSelect () {
            return this.creatableWorkItemTypes.filter((workItemType)=>workItemType.name !== WORK_ITEM_TYPE_NAME_TICKET).map((workItemType)=>({
                    value: workItemType.id,
                    text: workItemType.name
                }));
        },
        selectedWorkItemType () {
            return this.workItemTypes?.find((item)=>item.id === this.selectedWorkItemTypeId);
        },
        allowedParentTypesForSelectedType () {
            if (this.workItemTypes.length) {
                const widgetDefinitionsForCurrentType = this.workItemTypes.find((workItemType)=>workItemType.id === this.selectedWorkItemTypeId)?.widgetDefinitions || [];
                return widgetDefinitionsForCurrentType.find((widget)=>widget.type === WIDGET_TYPE_HIERARCHY)?.allowedParentTypes?.nodes || [];
            }
            return [];
        },
        selectedWorkItemTypeName () {
            return this.selectedWorkItemType?.name || '';
        },
        selectedWorkItemTypeIconName () {
            return this.selectedWorkItemType?.iconName;
        },
        formOptions () {
            const options = [
                ...this.workItemTypesForSelect
            ];
            if (!this.preselectedWorkItemType) {
                options.unshift({
                    value: null,
                    text: s__('WorkItem|Select type')
                });
            }
            return options;
        },
        createErrorText () {
            return sprintf(I18N_WORK_ITEM_ERROR_CREATING, {
                workItemType: this.selectedWorkItemTypeName
            });
        },
        createWorkItemText () {
            return sprintf(s__('WorkItem|Create %{workItemType}'), {
                workItemType: lowercaseWorkItemType(this.selectedWorkItemTypeName)
            });
        },
        makeConfidentialText () {
            return sprintf(s__('WorkItem|Turn on confidentiality: Limit visibility to %{namespace} members with at least the Planner role.'), {
                namespace: this.isGroup ? __('group') : __('project')
            });
        },
        titleText () {
            return sprintf(s__('WorkItem|New %{workItemType}'), {
                workItemType: lowercaseWorkItemType(this.selectedWorkItemTypeName)
            });
        },
        canUpdate () {
            return this.workItem?.userPermissions?.updateWorkItem;
        },
        workItemParticipantNodes () {
            return this.workItemParticipants?.participants?.nodes ?? [];
        },
        workItemParticipants () {
            return findParticipantsWidget(this.workItem);
        },
        workItemAssigneeIds () {
            return findAssigneesWidget(this.workItem)?.assignees?.nodes?.map((assignee)=>assignee.id) || [];
        },
        workItemLabelIds () {
            const labelsWidget = findLabelsWidget(this.workItem);
            return labelsWidget?.labels?.nodes?.map((label)=>label.id) || [];
        },
        workItemWeightValue () {
            const weightWidget = findWeightWidget(this.workItem);
            return weightWidget?.weight ?? null;
        },
        workItemMilestoneId () {
            return this.workItemMilestone?.milestone?.id || this.selectedParentMilestone?.id || null;
        },
        workItemCrmContactIds () {
            return findCrmContactsWidget(this.crmContactsWorkItem)?.contacts?.nodes?.map((item)=>item.id) || [];
        },
        workItemParent () {
            return this.workItemHierarchy?.parent || null;
        },
        workItemColorValue () {
            const colorWidget = findColorWidget(this.workItem);
            return colorWidget?.color || '';
        },
        workItemHealthStatusValue () {
            const healthStatusWidget = findHealthStatusWidget(this.workItem);
            return healthStatusWidget?.healthStatus || null;
        },
        workItemTitle () {
            return this.localTitle || this.workItem?.title || this.title;
        },
        workItemDescription () {
            const descriptionWidget = this.useWorkItemFeatures ? this.workItem?.features?.description : findWidget(WIDGET_TYPE_DESCRIPTION, this.workItem);
            return this.localDescription || descriptionWidget?.description || this.description;
        },
        workItemStartAndDueDate () {
            return this.useWorkItemFeatures ? this.workItem.features?.startAndDueDate : findWidget(WIDGET_TYPE_START_AND_DUE_DATE, this.workItem);
        },
        workItemIterationId () {
            return this.workItemIteration?.iteration?.id;
        },
        workItemId () {
            return this.workItem?.id;
        },
        workItemStatus () {
            return findStatusWidget(this.workItem);
        },
        workItemIid () {
            return this.workItem?.iid;
        },
        workItemStatusId () {
            return this.workItemStatus?.status?.id;
        },
        shouldIncludeRelatedItem () {
            return this.isWidgetSupported(WIDGET_TYPE_LINKED_ITEMS) && this.isRelatedToItem && this.relatedItemId;
        },
        resolvingMRDiscussionLink () {
            return document.querySelector('.params-discussion-to-resolve a')?.href || '';
        },
        resolvingMRDiscussionLinkText () {
            return document.querySelector('.params-discussion-to-resolve a')?.text || '';
        },
        createWorkItemWarning () {
            const warning = this.numberOfDiscussionsResolved === '1' ? this.$options.i18n.resolveOneThreadText : this.$options.i18n.resolveAllThreadsText;
            return sprintf(warning, {
                workItemType: lowercaseWorkItemType(this.selectedWorkItemTypeName)
            });
        },
        isFormFilled () {
            const isTitleFilled = Boolean(this.workItemTitle.trim());
            const isDescriptionFilled = Boolean(this.workItemDescription.trim());
            const defaultColorValue = DEFAULT_EPIC_COLORS;
            const isCustomFieldsFilled = Boolean(this.workItemCustomFields?.find((field)=>field.value != null || field.selectedOptions?.length > 0));
            return isTitleFilled || isDescriptionFilled || this.workItemAssigneeIds.length > 0 || this.workItemLabelIds.length > 0 || this.workItemCrmContactIds.length > 0 || Boolean(this.workItemColorValue) && this.workItemColorValue !== defaultColorValue || Boolean(this.workItemHealthStatusValue) || Boolean(this.workItemDueDateFixed) || Boolean(this.workItemStartDateFixed) || Boolean(this.workItemDueDateIsFixed) || Boolean(this.workItemStartDateIsFixed) || Boolean(this.workItemIterationId) || Boolean(this.workItemStatusId) || isCustomFieldsFilled;
        },
        shouldDatesRollup () {
            return this.workItemTypeConfiguration?.widgetDefinitions?.find((widget)=>widget.type === WIDGET_TYPE_START_AND_DUE_DATE)?.canRollUp;
        },
        workItemCustomFields () {
            return findCustomFieldsWidget(this.workItem)?.customFieldValues ?? null;
        },
        formButtonsClasses () {
            return this.isModal ? '-gl-mx-5 gl-px-5 gl-bg-overlap gl-py-3' : '-gl-mx-3 -gl-mb-10 gl-px-3 gl-bg-default gl-py-4';
        },
        selectedProjectGroupPath () {
            // Eventually, we should be able to select both groups and projects from a single interface in consolidated list.
            if (this.selectedNamespacePath && this.selectedNamespacePath.indexOf('/') === -1) {
                return this.selectedNamespacePath;
            }
            return this.selectedNamespacePath ? this.selectedNamespacePath.substring(0, this.selectedNamespacePath.lastIndexOf('/')) : this.groupPath;
        },
        namespaceSelectorLabel () {
            return this.projectsOnly ? __('Project') : __('Group/project');
        },
        projectsOnly () {
            // Epics are the only group-level work items right now. If the user cannot create epics,
            // then do not show groups since the user will not be able to create epics.
            if (!this.availableFeatures?.hasEpicsFeature) {
                return true;
            }
            return this.allowProjectsOnly;
        },
        workItemWidgetsAutoSaveKey () {
            return getNewWorkItemWidgetsAutoSaveKey({
                fullPath: this.selectedNamespacePath,
                context: this.creationContext,
                relatedItemId: this.relatedItemId
            });
        }
    },
    watch: {
        selectedNamespacePath () {
            // Reset configuration and types when namespace changes to prevent showing cached data from previous namespace
            this.workItemTypesConfiguration = {};
            this.initialLoadingWorkItemTypesConfiguration = true;
        },
        shouldDiscardDraft: {
            immediate: true,
            handler (shouldDiscardDraft) {
                // If this component is rendered in the create modal and user added data,
                // we need to track the button clicked on the confirmation modal (another modal)
                if (shouldDiscardDraft && this.selectedWorkItemTypeId) {
                    this.handleDiscardDraft();
                }
            }
        },
        /*
      Only needed for the cancellation confirmation modal
      when creating a work item in the project route,
      as you can choose the work item type in the dropdown
    */ selectedWorkItemTypeName (newValue) {
            this.$emit('update-type', newValue);
        },
        selectedWorkItemTypeId (newId) {
            if (newId) {
                // Whenever the ID changes, find the name and tell the parent
                const typeName = this.findWorkItemTypeById(newId)?.name;
                this.$emit('change-type', typeName);
            }
        }
    },
    mounted () {
        // We need this event listener in the document because when
        // updating widgets, the form may no be in focus and triggering
        // a keyboard event in the form won't get caught
        document.addEventListener('keydown', this.handleKeydown);
        this.setNumberOfDiscussionsResolved();
        addShortcutsExtension(ShortcutsWorkItems);
        new ZenMode(); // eslint-disable-line no-new
        // Set focus on title field
        this.$nextTick(async ()=>{
            await new Promise((resolve)=>{
                setTimeout(resolve, 250);
            });
            this.$refs.title?.focusInput?.();
        });
    },
    beforeDestroy () {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
        findWorkItemTypeById (workItemTypeId) {
            return this.workItemTypes?.find((workItemType)=>workItemType.id === workItemTypeId);
        },
        findCreatableWorkItemType (workItemTypeName) {
            return this.creatableWorkItemTypes?.find((workItemType)=>workItemType.name === workItemTypeName);
        },
        findCreatableWorkItemTypeById (workItemTypeId) {
            return this.creatableWorkItemTypes?.find((workItemType)=>workItemType.id === workItemTypeId);
        },
        setDefaultWorkItemType () {
            const issueTypeGid = convertToGraphQLId(TYPENAME_WORK_ITEMS_TYPE, 1);
            const defaultSelectedWorkItemType = this.creatableWorkItemTypes.find((type)=>type?.name === WORK_ITEM_TYPE_NAME_ISSUE || type?.id === issueTypeGid) || this.creatableWorkItemTypes.at(0);
            this.selectedWorkItemTypeId = defaultSelectedWorkItemType?.id;
            this.$emit('change-type', defaultSelectedWorkItemType?.name);
        },
        processWorkItemTypes () {
            // Only process if both queries have completed
            if (this.initialLoadingWorkItemTypes || this.initialLoadingWorkItemTypesConfiguration) {
                return;
            }
            if (!this.workItemTypes?.length) {
                return;
            }
            // The follow-up title and description are server-rendered into hidden
            // `.params-*` nodes only on the new work item full page (the `new`
            // controller action renders the show view with an unsaved work item) for:
            // 1. resolving a discussion in an MR (merge request id query param)
            // 2. prefilling via URL query params, see https://docs.gitlab.com/user/project/issues/create_issues/#using-a-url-with-prefilled-values
            // 3. following up a work item with a vulnerability (vulnerability id query param)
            // Only the new-route page carries these nodes. Other contexts (e.g. the list
            // modal) share the SPA document with the work item detail view, whose
            // `.params-*` nodes hold the viewed item's title and description and would
            // otherwise leak into the new item form.
            let workItemTitle = '';
            let workItemDescription = '';
            if (this.creationContext === CREATION_CONTEXT_NEW_ROUTE) {
                workItemTitle = document.querySelector('.params-title')?.textContent.trim();
                workItemDescription = document.querySelector('.params-description')?.textContent.trim();
            }
            for (const workItemType of this.workItemTypes){
                setNewWorkItemCache({
                    fullPath: this.selectedNamespacePath,
                    context: this.creationContext,
                    widgetDefinitions: workItemType?.widgetDefinitions,
                    workItemType: workItemType.name,
                    workItemTypeId: workItemType.id,
                    workItemTypeIconName: workItemType.iconName,
                    relatedItemId: this.relatedItemId,
                    workItemTitle,
                    workItemDescription,
                    confidential: this.isConfidential,
                    useWorkItemFeatures: this.useWorkItemFeatures
                });
            }
            const persistedTypeId = getLastUsedWorkItemTypeIdForNamespace(this.selectedNamespacePath);
            const selectedWorkItemType = this.findCreatableWorkItemType(this.preselectedWorkItemType) || this.findCreatableWorkItemTypeById(persistedTypeId);
            if (selectedWorkItemType) {
                updateDraftWorkItemType({
                    fullPath: this.selectedNamespacePath,
                    context: this.creationContext,
                    relatedItemId: this.relatedItemId,
                    workItemType: {
                        id: selectedWorkItemType.id,
                        name: selectedWorkItemType.name,
                        iconName: selectedWorkItemType.iconName
                    }
                });
            }
            if (selectedWorkItemType) {
                this.selectedWorkItemTypeId = selectedWorkItemType?.id;
                this.$emit('change-type', selectedWorkItemType.name);
            } else {
                this.setDefaultWorkItemType();
            }
        },
        initialSelectedProject () {
            if (this.relatedItem) {
                return this.relatedItem.reference.substring(0, this.relatedItem.reference.lastIndexOf('#'));
            }
            return this.fullPath || null;
        },
        handleKeydown (e) {
            if (isMetaEnterKeyPair(e) && !this.loading) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.createWorkItem();
            }
        },
        validateAllowedParentTypes (selectedWorkItemType) {
            return this.workItemTypes?.find((type)=>type.name === selectedWorkItemType)?.widgetDefinitions.find((widget)=>widget.type === WIDGET_TYPE_HIERARCHY)?.allowedParentTypes?.nodes || [];
        },
        isWidgetSupported (widgetType) {
            const widgetDefinitions = this.selectedWorkItemType?.widgetDefinitions?.flatMap((i)=>i.type) || [];
            return widgetDefinitions.indexOf(widgetType) !== -1;
        },
        validate () {
            this.isTitleValid = Boolean(String(this.workItemTitle).trim()) && String(this.workItemTitle).trim().length <= TITLE_LENGTH_MAX;
        },
        setNumberOfDiscussionsResolved () {
            if (this.discussionToResolve || this.mergeRequestToResolveDiscussionsOf) {
                this.numberOfDiscussionsResolved = this.discussionToResolve && this.mergeRequestToResolveDiscussionsOf ? '1' : 'all';
            }
        },
        clearAutosaveDraft () {
            const fullDraftAutosaveKey = getNewWorkItemAutoSaveKey({
                fullPath: this.selectedNamespacePath,
                context: this.creationContext,
                workItemType: this.selectedWorkItemTypeName,
                relatedItemId: this.relatedItemId
            });
            if (fullDraftAutosaveKey) {
                clearDraft(fullDraftAutosaveKey);
            }
            clearDraft(this.workItemWidgetsAutoSaveKey);
        },
        handleNamespaceSelect (_, namespaceObject) {
            this.selectedNamespaceObject = namespaceObject;
        },
        handleChangeType () {
            setNewWorkItemCache({
                fullPath: this.selectedNamespacePath,
                context: this.creationContext,
                widgetDefinitions: this.selectedWorkItemType?.widgetDefinitions || [],
                workItemType: this.selectedWorkItemTypeName,
                workItemTypeId: this.selectedWorkItemTypeId,
                workItemTypeIconName: this.selectedWorkItemTypeIconName,
                relatedItemId: this.relatedItemId,
                useWorkItemFeatures: this.useWorkItemFeatures
            });
            updateDraftWorkItemType({
                fullPath: this.selectedNamespacePath,
                context: this.creationContext,
                relatedItemId: this.relatedItemId,
                workItemType: {
                    id: this.selectedWorkItemTypeId,
                    name: this.selectedWorkItemTypeName,
                    iconName: this.selectedWorkItemTypeIconName
                }
            });
            this.$emit('change-type', this.selectedWorkItemTypeName);
        },
        async updateDraftData (type, value) {
            // loading is set to true at the start of createWorkItem and intentionally
            // never reset on success because the component is destroyed shortly after.
            // This prevents async draft writes from re-populating localStorage after
            // clearAutosaveDraft has already cleared it.
            if (this.loading) return;
            switch(type){
                case 'title':
                    this.localTitle = value;
                    this.validate();
                    break;
                case 'description':
                    this.localDescription = value;
                    break;
                default:
                    break;
            }
            await this.handleUpdateWidgetDraft({
                [type]: value
            });
        },
        async createWorkItem () {
            this.validate();
            if (!this.isTitleValid) {
                return;
            }
            // This flag is used in `updateDraftData` and in `handleUpdateWidgetDraft`
            this.loading = true;
            const workItemCreateInput = {
                title: this.workItemTitle,
                workItemTypeId: this.selectedWorkItemTypeId,
                namespacePath: this.selectedNamespacePath || this.fullPath,
                confidential: this.workItem.confidential,
                descriptionWidget: {
                    description: this.workItemDescription || ''
                }
            };
            if (this.createSource) {
                workItemCreateInput.createSource = this.createSource;
            } else if (this.vulnerabilityId) {
                workItemCreateInput.createSource = WORK_ITEM_CREATE_SOURCES.VULNERABILITY;
            }
            if (this.discussionToResolve || this.mergeRequestToResolveDiscussionsOf) {
                workItemCreateInput.discussionsToResolve = {
                    discussionId: this.discussionToResolve,
                    noteableId: convertToGraphQLId(TYPENAME_MERGE_REQUEST, this.mergeRequestToResolveDiscussionsOf)
                };
            }
            if (this.vulnerabilityId) {
                workItemCreateInput.vulnerabilityId = convertToGraphQLId(TYPENAME_VULNERABILITY, this.vulnerabilityId);
            }
            // TODO , we can move this to util, currently objectives with other widgets not being supported is causing issues
            if (this.isWidgetSupported(WIDGET_TYPE_COLOR)) {
                workItemCreateInput.colorWidget = {
                    color: this.workItemColorValue
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_ASSIGNEES)) {
                workItemCreateInput.assigneesWidget = {
                    assigneeIds: this.workItemAssigneeIds
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_HEALTH_STATUS)) {
                workItemCreateInput.healthStatusWidget = {
                    healthStatus: this.workItemHealthStatusValue
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_LABELS)) {
                workItemCreateInput.labelsWidget = {
                    labelIds: this.workItemLabelIds
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_ITERATION)) {
                workItemCreateInput.iterationWidget = {
                    iterationId: this.workItemIterationId
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_WEIGHT)) {
                workItemCreateInput.weightWidget = {
                    weight: this.workItemWeightValue
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_MILESTONE)) {
                workItemCreateInput.milestoneWidget = {
                    milestoneId: this.workItemMilestoneId
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_START_AND_DUE_DATE)) {
                workItemCreateInput.startAndDueDateWidget = {
                    isFixed: this.workItemStartAndDueDate.isFixed,
                    startDate: this.workItemStartAndDueDate.startDate,
                    dueDate: this.workItemStartAndDueDate.dueDate
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_CRM_CONTACTS)) {
                workItemCreateInput.crmContactsWidget = {
                    contactIds: this.workItemCrmContactIds
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_STATUS)) {
                workItemCreateInput.statusWidget = {
                    status: this.workItemStatusId
                };
            }
            if (this.shouldIncludeRelatedItem) {
                workItemCreateInput.linkedItemsWidget = {
                    workItemsIds: [
                        this.relatedItem.id
                    ]
                };
            }
            if (this.mergeRequestId && this.isWidgetSupported(WIDGET_TYPE_DEVELOPMENT)) {
                workItemCreateInput.developmentWidget = {
                    mergeRequestIds: [
                        this.mergeRequestId
                    ],
                    ...this.mergeRequestLinkType && {
                        linkType: this.mergeRequestLinkType
                    }
                };
            }
            if (this.parentId || this.isWidgetSupported(WIDGET_TYPE_HIERARCHY) && this.workItemParent?.id) {
                workItemCreateInput.hierarchyWidget = {
                    parentId: this.workItemParent?.id ?? this.parentId
                };
            }
            if (this.isWidgetSupported(WIDGET_TYPE_CUSTOM_FIELDS)) {
                const customFieldsMutationInput = this.workItemCustomFields?.map((field)=>{
                    if (field.customField.fieldType === CUSTOM_FIELDS_TYPE_NUMBER) {
                        return {
                            customFieldId: field.customField.id,
                            numberValue: field.value
                        };
                    }
                    if (field.customField.fieldType === CUSTOM_FIELDS_TYPE_TEXT) {
                        return {
                            customFieldId: field.customField.id,
                            textValue: field.value
                        };
                    }
                    const selectedOptionsIds = field.selectedOptions?.map(({ id })=>id);
                    return {
                        customFieldId: field.customField.id,
                        selectedOptionIds: selectedOptionsIds
                    };
                });
                workItemCreateInput.customFieldsWidget = customFieldsMutationInput;
            }
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: createWorkItemMutation,
                    variables: {
                        input: {
                            ...workItemCreateInput
                        },
                        useWorkItemFeatures: this.useWorkItemFeatures
                    },
                    update: (store, { data: { workItemCreate } })=>{
                        const { workItem } = workItemCreate;
                        if (this.parentId || this.isWidgetSupported(WIDGET_TYPE_HIERARCHY) && this.workItemParent?.id) {
                            addHierarchyChild({
                                cache: store,
                                id: this.workItemParent?.id ?? this.parentId,
                                workItem
                            });
                        }
                    }
                });
                if (data.workItemCreate.errors.length) {
                    throw new Error(data.workItemCreate.errors);
                }
                setLastUsedWorkItemTypeIdForNamespace(this.selectedWorkItemTypeId, this.selectedNamespacePath);
                this.clearAutosaveDraft();
                this.$emit('work-item-created', {
                    workItem: data.workItemCreate.workItem,
                    numberOfDiscussionsResolved: this.numberOfDiscussionsResolved
                });
            } catch (error) {
                this.error = error.message || this.createErrorText;
                Sentry.captureException(error);
            } finally{
                this.loading = false;
            }
        },
        async handleUpdateWidgetDraft (input) {
            // See comment in updateDraftData for why we guard on this.loading
            if (this.loading) return;
            try {
                await this.$apollo.mutate({
                    mutation: updateNewWorkItemMutation,
                    variables: {
                        input: {
                            fullPath: this.selectedNamespacePath,
                            context: this.creationContext,
                            workItemType: this.selectedWorkItemTypeName,
                            relatedItemId: this.relatedItemId,
                            useWorkItemFeatures: this.useWorkItemFeatures,
                            ...input
                        }
                    }
                });
            } catch (e) {
                this.error = this.createErrorText;
                Sentry.captureException(e);
            }
        },
        handleCancelClick () {
            /*
       * If any form field is filled or has a non-default value, ask user to confirm
       * if they want to discard the draft
       */ if (this.isFormFilled) {
                this.$emit('confirm-cancel');
            } else {
                this.$emit('discard-draft');
                this.handleDiscardDraft();
            }
        },
        handleDiscardDraft () {
            this.clearAutosaveDraft();
            const selectedWorkItemWidgets = this.selectedWorkItemType?.widgetDefinitions || [];
            setNewWorkItemCache({
                fullPath: this.selectedNamespacePath,
                context: this.creationContext,
                widgetDefinitions: selectedWorkItemWidgets,
                workItemType: this.selectedWorkItemTypeName,
                workItemTypeId: this.selectedWorkItemTypeId,
                workItemTypeIconName: this.selectedWorkItemTypeIconName,
                relatedItemId: this.relatedItemId,
                useWorkItemFeatures: this.useWorkItemFeatures
            });
        },
        onParentMilestone (parentMilestone) {
            this.selectedParentMilestone = parentMilestone;
        }
    },
    NEW_WORK_ITEM_IID,
    NEW_WORK_ITEM_GID
};
